/**
 * @generated SignedSource<<c27bc5c9869fca21ba25efedf3a7f8a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CodepushSeverityEnum = "tier1" | "tier2" | "tier3" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CodepushVersionUpdateDialog_codepushVersion$data = {
  readonly id: string;
  readonly severity: CodepushSeverityEnum;
  readonly title: string;
  readonly " $fragmentType": "CodepushVersionUpdateDialog_codepushVersion";
};
export type CodepushVersionUpdateDialog_codepushVersion$key = {
  readonly " $data"?: CodepushVersionUpdateDialog_codepushVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"CodepushVersionUpdateDialog_codepushVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CodepushVersionUpdateDialog_codepushVersion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "severity",
      "storageKey": null
    }
  ],
  "type": "CodepushVersion",
  "abstractKey": null
};

(node as any).hash = "2b57f6ba90079914f0249514341a82c7";

export default node;
